import Modal from "react-bootstrap/Modal";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import cookie from "js-cookie";
import { useRouter } from "next/router";
import { getProductQuery, sizeOptionsList, steps } from "./constants";
import ContactForm from "./form";

/**
 * Modal to submit landing page form
 *
 * @param {Object} props - Component props
 * @param {function} onHide - Function to hide the modal
 * @param {boolean} show - Show or hide the modal
 */
function HomeOwnerForm({ onHide, show }) {
  const router = useRouter();

  const [step, setStep] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [showResult, setShowResult] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [count, setCount] = useState(3);

  useEffect(() => {
    if (showResult) {
      if (count <= 0) return; // Stop countdown at 0

      const timer = setInterval(() => {
        setCount((prevCount) => prevCount - 1);
      }, 1000);

      return () => clearInterval(timer); // Cleanup interval on unmount
    }
  }, [count, showResult]);

  // TODO: This function is removed due to client but kept in case we need it in the future
  // fetchData - Fetch data from the server
  const fetchData = async (value, limit = true) => {
    setLoading(true);
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var graphql = JSON.stringify({
      variables: {
        filter: { category_id: { in: [value] } },
        sort: { recommended: "ASC" },
        pageSize: 14,
        currentPage: 1,
      },
      query: getProductQuery,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: graphql,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        "https://proxy.orientbell.com",
        requestOptions
      );
      const result = await response.json();
      const tileSizeAggregation = result.data.products.aggregations.find(
        (item) => item.attribute_code === "tile_size"
      );
      let options = tileSizeAggregation.options;

      if (limit && Array.isArray(options)) {
        options = options.slice(0, 6);
      }

      setLoading(false);
      return options || [];
    } catch (error) {
      console.log("Error fetching data:", error);
      setLoading(false);
      return [];
    }
  };

  useEffect(() => {
    const showCookie = cookie.get("homeowner");
    if (showCookie === undefined) {
      setShowModal(true);
    } else if (showCookie === "false") {
      closeModal(false);
    }
  }, []);

  const navigateToPage = () => {
    setShowResult(true);
    console.log(selectedOptions[3]);

    // url for navigation
    let url = `/tiles/${selectedOptions[1].url}?tile_size=${
      selectedOptions[3].value
    }${selectedOptions[2].value ? "&" + selectedOptions[2].value : ""}`;

    // console.log(url);
    // close modal
    setTimeout(() => {
      closeModal();
      router.push(url);
    }, 4000);
  };

  useEffect(() => {
    if (step === 3 && selectedOptions[3]) navigateToPage();
  }, [selectedOptions, step]);

  const closeModal = (setCookie = true) => {
    if (setCookie) cookie.set("homeowner", "true", { expires: 7 });
    setShowModal(false);
    onHide();
  };

  const handleSelect = async (option, index) => {
    if (step === 0 && option.label !== "Homeowner") {
      // closeModal();

      const selectedStep = {
        ...selectedOptions,
        [step]: option,
      };
      setSelectedOptions(selectedStep);
      setShowForm(true);
      return;
    }

    steps[step].options.forEach((item) => (item.action = false));
    steps[step].options[index] = { ...option, action: true };

    const selectedStep = {
      ...selectedOptions,
      [step]: option,
    };
    setSelectedOptions(selectedStep);

    if (step === 1) {
      // TODO: this function is removed due to client but kept in case we need it in the future
      // const options = await fetchData(option.value, true);
      // setSizeOptions();

      steps[3].options = sizeOptionsList[option.label];

      if (option.label === "Elevation") {
        steps[2].options = [
          { label: "Wall", value: "tile_category=223" },
          { label: "Both", value: "" },
        ];
      }
    }

    if (step < steps.length - 1) {
      setStep(step + 1);
    }
  };

  return showModal ? (
    <div className="home-owner-form">
      <Modal className="owner-popup-design" show={show} onHide={closeModal}>
        <div className="main-location-popup">
          <Modal.Dialog>
            <Modal.Header closeButton>
              <Modal.Title>
                {showForm
                  ? "We Will Contact you"
                  : showResult
                  ? "Result Tiles"
                  : steps[step].question}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* Navigation summary showing answered steps */}
              <div className="selected-options-summary">
                {!showResult &&
                  Object.entries(selectedOptions).map(
                    ([key, option], index) => (
                      <div key={key}>
                        {index !== 0 && " > "}
                        <button
                          onClick={() => {
                            if (key === "0" && option.label !== "Homeowner") {
                              setShowForm(false);
                            }
                            setSelectedOptions((prevOptions) => {
                              // Create a shallow copy of the previous state
                              const newOptions = { ...prevOptions };
                              // Remove any selections with a step greater than the clicked step
                              Object.keys(newOptions).forEach((stepKey) => {
                                if (Number(stepKey) > Number(key)) {
                                  delete newOptions[stepKey];
                                }
                              });
                              return newOptions;
                            });
                            setStep(Number(key));
                          }}
                          className="summary-button"
                        >
                          {/* step */}
                          {key === "0" &&
                          option.label !== "Homeowner" &&
                          showForm
                            ? "< Go Back"
                            : option.label !== "Homeowner" && key === "0"
                            ? ""
                            : option.label}
                        </button>
                      </div>
                    )
                  )}
              </div>
              {loading ? (
                <div>loading...</div>
              ) : (
                <div className="container">
                  <motion.div
                    key={step}
                    initial={{ x: "100%", opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: "-100%", opacity: 0 }}
                    transition={{ duration: 0.5 }}
                    className="step-container"
                  >
                    {showForm ? (
                      <ContactForm
                        close={closeModal}
                        goBack={() => {
                          setShowForm(false);
                          setStep(1);
                        }}
                      />
                    ) : (
                      // <></>
                      <>
                        {showResult ? (
                          <div>
                            <p>
                              Here are the best tile options based on your
                              preferences.
                            </p>
                            <br />
                            <p> you will be redirected in {count} seconds</p>
                          </div>
                        ) : (
                          <div className="options">
                            {
                              // TODO: this is removed due to client but kept in case we need it in the future
                              // step === 2
                              // ? sizeOptions.map((option) => (
                              //     <button
                              //       key={option.value}
                              //       onClick={() => handleSelect(option)}
                              //     >
                              //       {option.label}
                              //     </button>
                              //   ))
                              //   :
                              steps[step].options.map((option, index) => (
                                <button
                                  key={option.value}
                                  onClick={() => handleSelect(option, index)}
                                  style={
                                    option.action === true
                                      ? {
                                          backgroundColor: "#0f9243",
                                          border: "1px solid #0f9243",
                                          color: "#fff",
                                        }
                                      : {}
                                  }
                                >
                                  {option.label}
                                </button>
                              ))
                            }
                          </div>
                        )}
                      </>
                    )}
                  </motion.div>
                </div>
              )}
              <style jsx>{`
                .container {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  overflow: hidden;
                }
                .step-container {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  gap: 1rem;
                  background: white;
                  padding: 2rem;
                  border-radius: 8px;
                  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
                }
                .options button {
                  margin: 5px;
                  padding: 10px 15px;
                  border: none;
                  background: #0070f3;
                  color: white;
                  cursor: pointer;
                  border-radius: 5px;
                  transition: background 0.3s;
                }
                .options button:hover {
                  background: #005bb5;
                }
                .selected-options-summary {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 10px;
                  margin-bottom: 1rem;
                  justify-content: center;
                }
                .summary-button {
                  background: #eee;
                  border: none;
                  padding: 8px 12px;
                  border-radius: 4px;
                  cursor: pointer;
                  transition: background 0.3s;
                }
                .summary-button:hover {
                  background: #ccc;
                }
              `}</style>
            </Modal.Body>
          </Modal.Dialog>
        </div>
      </Modal>
    </div>
  ) : null;
}

export default HomeOwnerForm;
